import { TKapabilitas } from './types'

export const arrayParticipantRoleMapper = (
  record: TKapabilitas[] | TKapabilitas | null,
  defaultRole: TKapabilitas = 'peserta',
): TKapabilitas => {
  if (!record || (Array.isArray(record) && !record.length)) return defaultRole
  return Array.isArray(record) ? record[0] : record
}
